import { addToCart } from '../modules/cart.js';

const selectors = {
  form: '[data-product-form]',
  variantId: 'input[name="id"]',
  addToCart: {
    button: '[data-add-to-cart-button]',
  },
  quantity: {
    container: '[data-quantity-container]',
    input: '[data-quantity-input]',
    minus: '[data-quantity-minus]',
    plus: '[data-quantity-plus]',
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.$form = document.querySelector(selectors.form);

    if (!this.$form) {
      return;
    }

    this.$addToCartButton = this.$form.querySelector(
      selectors.addToCart.button
    );
    this.$variantId = this.$form.querySelector(selectors.variantId);

    this.quantity = 1;
    this.variantId = this.$variantId.value;

    this.registerEventListeners();
  }

  registerEventListeners() {
    this.$quantities = this.$form.querySelectorAll(
      selectors.quantity.container
    );
    this.$quantities.forEach($quantity => {
      const $quantityInput = $quantity.querySelector(selectors.quantity.input);
      const $quantityMinus = $quantity.querySelector(selectors.quantity.minus);
      const $quantityPlus = $quantity.querySelector(selectors.quantity.plus);

      $quantityInput.addEventListener('change', () => {
        const value = Number($quantityInput.value);

        if (value < 1) {
          $quantityInput.value = 1;
        }
      });
      $quantityMinus.addEventListener('click', () => {
        const value = Number($quantityInput.value);

        if (value > 1) {
          $quantityInput.value = value - 1;
          this.quantity = $quantityInput.value;
        }
      });

      $quantityPlus.addEventListener('click', () => {
        const value = Number($quantityInput.value);
        $quantityInput.value = value + 1;
        this.quantity = $quantityInput.value;
      });
    });

    this.$addToCartButton.addEventListener('click', event => {
      event.preventDefault();

      const { addingToCart } = this.$addToCartButton.dataset;
      this.$addToCartButton.innerHTML = addingToCart;

      // This logic checks the selling_plan query param set by Recharge
      // then adds it as a line item attribute. If there is no selling plan
      // it returns 0.
      const params = new URLSearchParams(window.location.search);

      const sellingPlanId = Number(params.get('selling_plan'));

      // Adding the product to the cart.
      addToCart(
        {
          items: [
            {
              id: this.variantId,
              quantity: this.quantity,
              ...(sellingPlanId > 0 && { selling_plan: sellingPlanId }),
            },
          ],
        },
        {
          element: this.$form,
          eventOptions: {
            detail: {
              action: 'open-cart-modal',
            },
          },
        }
      );
    });
  }
}

customElements.define('product-form', ProductForm);
